import { hubCall } from "@/lib/api/hub";
import type { ApiResponse } from "@/types/api.types";
import type { ReadinessResponse } from "@/types/llm-readiness.types";

/**
 * AiConfig Service — calls the /v1/cms/aiconfig/* endpoints.
 * Readiness check is member-readable; no secrets in response.
 */
export const aiconfigService = {
  /**
   * Fetch current readiness state for all use-cases.
   * Response shape mirrors `GET /v1/cms/aiconfig/readiness` camelCase wire.
   * Backend wraps payload in `{ data: ... }` envelope (datatype.ResponseData);
   * we unwrap so consumers can access useCases directly.
   * Backend caches the result for 60s — FE matches with staleTime: 60_000.
   */
  async getReadiness(): Promise<ReadinessResponse> {
    const envelope = await hubCall<ApiResponse<ReadinessResponse>>(
      "/aiconfig/readiness",
    );
    return envelope.data;
  },
};
